
let interval;
export default (store) => {
  if(interval){
    clearInterval(interval);
  }
  interval = setInterval(()=>{
    store.commit('refreshTime');
  }, 1000);
  store.commit('refreshTime');
}
